module.exports = __webpack_public_path__ + "static/iphone-5-portrait-c2fdb97dc3b904f5964ab7eac6f1fa93.png";